import Vue from 'vue';
import { firestorePlugin, rtdbPlugin } from 'vuefire';

import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
Vue.use(firestorePlugin);
Vue.use(rtdbPlugin);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
